import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OutstationService {

  routeDetails = new BehaviorSubject(null);
  hideBackBtn = new BehaviorSubject(null);

  constructor() { }
}
